export const lux_chess_set = {
  product_id: "7",
  grid_type: "1",
  cover_image: "/1.jpg",
  product_name: "Schachspiel",
  media: ["1.jpg", "2.jpg", "3.jpg", "4.jpg", "5.jpg", "6.jpg", "7.jpg", "8.jpg", "9.jpg"],
  product_price: 122.0,
  product_slug: "lux-chess-set",
  short_description: "Das luxuriöse Schachspiel aus hochwertigem Acrylglas verbindet zeitlose Eleganz mit moderner Ästhetik. Handgefertigt mit diamantgeschliffenen Rändern, wird es in einem stilvollen Plexiglasdisplay präsentiert – ein Kunstwerk, das sowohl spielerische Raffinesse als auch dekorative Exklusivität ausstrahlt.",
  description: `
  Tauchen Sie ein in zeitlose Eleganz mit unserem Schachspiel aus Acrylglas.
  <br><br>
  Wir stellen Ihnen unser luxuriöses Schachset vor, ein wahres Meisterwerk, das über das reine Spiel hinausgeht. Dieses exquisite Set ist in einem eindrucksvollen Plexiglasdisplay untergebracht und vereint Kunstfertigkeit und Intellekt in einem einzigen, eleganten Ensemble. Jedes Teil dieses Sets wurde von unseren erfahrenen Handwerkern sorgfältig entworfen. Von unseren besten Handwerkern in unserem Atelier handgefertigt, sind diese Stücke ein Zeugnis für Präzision und Hingabe. Die Designs fügen sich nahtlos in verschiedene Umgebungen ein, sei es Ihr Schreibtisch, Couchtisch, Beistelltisch, die Konsole oder das Regal. Das „Schachspiel" ist nicht nur ein Spiel, sondern ein Kunstwerk, das Ihrem Wohnraum Raffinesse und Faszination verleiht und dadurch Ihren Wohnbereich aufwertet. Dieses Set ist das perfekte Geschenk, um Liebe und Wertschätzung für Ihre Liebsten auszudrücken.
  <br><br>
  Ob zu einem besonderen Anlass oder als aufmerksame Geste: Das „Schachspiel" symbolisiert den zeitlosen Wert von Handwerkskunst und Intellekt. Bereichern Sie Ihr Schacherlebnis und schmücken Sie Ihren Raum mit dieser außergewöhnlichen Kreation.
  <br><br>
  <h6> PRODUKTPFLEGE </h6>
  Um das makellose Aussehen Ihres „Schachspiel " zu erhalten, verwenden Sie ein weiches, trockenes Tuch, um Staub zu entfernen, der sich im Laufe der Zeit ansammeln kann. So sieht Ihr Neujahrsferien-Set am besten aus und behält seine transparente Brillanz.
  <br><br>
  Wenn Sie diese Pflegerichtlinien befolgen, können Sie sicherstellen, dass Ihr „Schachspiel " weiterhin glänzt und Ihre Inneneinrichtung über Jahre hinweg bereichert.
  `,
  specifications: {
    rows: [
      { name: "Material", value: "Hochwertiges Acrylglas" },
      { name: "Abmessungen", value: "25cm x 25cm x 2,3cm" },
      { name: "Gewicht", value: "1671 Gramm" },
      { name: "Farbe", value: "Transparent" },
      { name: "Ränder", value: "Diamantgeschliffen" },
    ],
    description: `Diese Spezifikationen unterstreichen die erstklassige Qualität und Präzision Ihres „Weihnachtsbaum"-Produkts und machen potenziellen Kunden deutlich, was sie in Bezug auf Material, Größe, Gewicht, Farbe und Ausführung erwarten können.
    `,
  },
  category: "Table",
  title_color: "#ffffff",
  subtitle_color: "#999999",
  price_color: "#ffffff"
};
